import { Link } from 'react-router-dom';

import { Cell } from 'components/Datatable';

import theme from 'core/ThemeConstants';

import sliceDate, { roundFloat } from 'utils/helper';

const userColumns = [
  {
    minWidth: 130,
    Header: 'Name',
    accessor: 'name',
    Cell: ({ row }) => {
      const { name } = row.original;

      return <Cell content={name} />;
    },
  },
  {
    minWidth: 200,
    Header: 'Email',
    accessor: 'email',
    Cell: ({ row }) => {
      const { email } = row.original;

      return <Cell content={email} />;
    },
  },
  {
    minWidth: 150,
    Header: 'Credits left',
    accessor: 'balance',
    Cell: ({ row }) => {
      const { balance } = row.original;
      const floatBalance = roundFloat(balance);
      return <Cell content={floatBalance} />;
    },
  },
  {
    minWidth: 300,
    Header: 'Secret key',
    accessor: 'secret',
    Cell: ({ row }) => {
      const { secret } = row.original;

      return <Cell content={secret} />;
    },
  },
  {
    minWidth: 150,
    Header: 'Created at',
    accessor: 'createdAt',
    Cell: ({ row }) => {
      const { createdAt } = row.original;

      return <Cell content={sliceDate(createdAt)} />;
    },
  },
  {
    minWidth: 150,
    Header: 'Go to account',
    accessor: 'account',
    Cell: ({ row }) => {
      const { id } = row.original;
      const buttonStyles = {
        display: 'inline-block',
        width: '80px',
        padding: '8px 5px',
        border: `1px solid ${theme.black.default}`,
        color: theme.black.default,
      };

      const userAccountPath = `/account/${id}`;

      const button = (
        <Link to={userAccountPath} style={buttonStyles}>
          Go
        </Link>
      );

      return <Cell content={button} smallTextAlign="center" />;
    },
  },
];

export default userColumns;
